export const WECHAT_GRANT = 'WECHAT_GRANT';
export const WECHAT_JSSDK = 'WECHAT_JSSDK';
export const FETCH_WECHAT_USER = 'FETCH_WECHAT_USER';
export const FETCH_WECHAT_TRAINER = 'FETCH_TRAINER';



// WEBPACK FOOTER //
// ./src/store/wechat/types.js